/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Faq_Q1Inputs */

const en_sorter_faq_q1 = /** @type {(inputs: Sorter_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are nested keys sorted too?`)
};

const ko_sorter_faq_q1 = /** @type {(inputs: Sorter_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중첩된 키도 정렬되나요?`)
};

const ja_sorter_faq_q1 = /** @type {(inputs: Sorter_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネストされたキーもソートされますか？`)
};

/**
* | output |
* | --- |
* | "Are nested keys sorted too?" |
*
* @param {Sorter_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_faq_q1 = /** @type {((inputs?: Sorter_Faq_Q1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Faq_Q1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_faq_q1(inputs)
	if (locale === "ko") return ko_sorter_faq_q1(inputs)
	return ja_sorter_faq_q1(inputs)
});